<div class="flex flex-col w-full h-full">
  <div class="flex-grow">
    <p-scrollPanel [style]="{width: '100%', height: '67vh'}">
      <!-- Loading State -->
      <div *ngIf="!isPageReady" class="flex items-center justify-center h-full">
        <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
      </div>

      <div *ngIf="isPageReady" class="narrative-container">
        <!-- Hero Header -->
        <div class="narrative-hero">
          <h1 class="narrative-hero-title">{{ program.name }}</h1>
          <p class="narrative-hero-subtitle">{{ account.name }} &bull; {{ program.programType.name }} Program</p>
          <div *ngIf="program.description" class="narrative-hero-subtitle" style="margin-top: 8px;">
            {{ program.description }}
          </div>
          <div [class]="'narrative-status-badge ' + getStatusClass()">
            <i [class]="getStatusIcon()"></i>
            {{ program.activeStatus.name }}
          </div>
        </div>

        <!-- Summary Section -->
        <div *ngIf="isSummary" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-summary">
              <i class="fa-duotone fa-memo-circle-info"></i>
            </div>
            <h2 class="narrative-section-title">Program Overview</h2>
          </div>
          <div class="narrative-section-content">
            <p [innerHtml]="summaryHtml"></p>
          </div>
        </div>

        <!-- Status Section -->
        <div *ngIf="isStatus" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-status">
              <i class="fa-duotone fa-signal-bars"></i>
            </div>
            <h2 class="narrative-section-title">Current Status</h2>
          </div>
          <div class="narrative-section-content">
            <p [innerHtml]="statusHtml"></p>
          </div>
        </div>

        <!-- Term Section -->
        <div *ngIf="isTerm" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-term">
              <i class="fa-duotone fa-calendar-range"></i>
            </div>
            <h2 class="narrative-section-title">Program Term</h2>
          </div>
          <div class="narrative-section-content">
            <p [innerHtml]="termHtml"></p>
            <div class="narrative-info-grid">
              <div class="narrative-info-item">
                <span class="narrative-info-label">Start Date</span>
                <span class="narrative-info-value">{{ program.startDate | date:'mediumDate' }}</span>
              </div>
              <div *ngIf="program.endDate" class="narrative-info-item">
                <span class="narrative-info-label">End Date</span>
                <span class="narrative-info-value">{{ program.endDate | date:'mediumDate' }}</span>
              </div>
              <div *ngIf="program.durationDays" class="narrative-info-item">
                <span class="narrative-info-label">Duration</span>
                <span class="narrative-info-value">{{ program.durationDays }} days</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Parameters Section -->
        <div *ngIf="isParameters" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-parameters">
              <i class="fa-duotone fa-sliders"></i>
            </div>
            <h2 class="narrative-section-title">Program Parameters</h2>
          </div>
          <div class="narrative-section-content">
            <!-- Allowances -->
            <div *ngIf="program.programAllowances.length > 0">
              <p [innerHtml]="allowanceParametersHtml"></p>
              <div *ngFor="let allowance of program.programAllowances" class="narrative-subsection">
                <div class="narrative-subsection-header">
                  <i class="fa-duotone fa-piggy-bank"></i>
                  {{ allowance.name }}
                </div>
                <div class="narrative-subsection-content">
                  <p [innerHTML]="getAllowance(allowance)"></p>
                </div>
              </div>
            </div>

            <!-- Issuances -->
            <div *ngIf="program.programIssuances.length > 0" [style.marginTop]="program.programAllowances.length > 0 ? '20px' : '0'">
              <p [innerHtml]="issuanceParametersHtml"></p>
              <div *ngFor="let issuance of program.programIssuances" class="narrative-subsection">
                <div class="narrative-subsection-header">
                  <i class="fa-duotone fa-boxes-stacked"></i>
                  {{ issuance.name }}
                </div>
                <div class="narrative-subsection-content">
                  <p [innerHTML]="getIssuance(issuance)"></p>
                </div>
              </div>
            </div>

            <!-- No Parameters -->
            <div *ngIf="program.programAllowances.length === 0 && program.programIssuances.length === 0">
              <div class="narrative-callout">
                <i class="fa-duotone fa-circle-info"></i>
                <div class="narrative-callout-content" [innerHtml]="noParametersHtml"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Account Issuance Limits Section -->
        <div *ngIf="isAccountIssuances" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-parameters">
              <i class="fa-duotone fa-gauge-max"></i>
            </div>
            <h2 class="narrative-section-title">Account Issuance Limits</h2>
          </div>
          <div class="narrative-section-content">
            <p [innerHtml]="accountIssuanceParametersHtml"></p>
            <div *ngFor="let ai of accountIssuances" class="narrative-subsection">
              <div class="narrative-subsection-header">
                <i class="fa-duotone fa-gauge-max"></i>
                {{ ai.name }}
              </div>
              <div class="narrative-subsection-content">
                <p [innerHTML]="getAccountIssuance(ai)"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- User Groups Section -->
        <div *ngIf="isUserGroups" class="narrative-section">
          <div class="narrative-section-header">
            <div class="narrative-section-icon icon-users">
              <i class="fa-duotone fa-users"></i>
            </div>
            <h2 class="narrative-section-title">Participating User Groups</h2>
          </div>
          <div class="narrative-section-content">
            <p>The following user groups have access to the <strong>{{ program.name }}</strong> program:</p>
            <div class="narrative-table-container">
              <p-table [value]="userGroupDtos" styleClass="p-datatable-sm">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="text-align: left;">User Group</th>
                    <th style="text-align: center; width: 120px;">Users</th>
                    <th style="text-align: center; width: 120px;">Excluded</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dto>
                  <tr>
                    <td style="font-weight: 500;">{{ dto.userGroupName }}</td>
                    <td style="text-align: center;">{{ dto.userCount }}</td>
                    <td style="text-align: center;">{{ dto.excludedUserCount }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="3" style="text-align: center; font-style: italic; color: var(--p-text-muted-color);">
                      No user groups assigned to this program.
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </div>
      </div>
    </p-scrollPanel>
  </div>

  <!-- Footer -->
  <div class="narrative-footer flex gap-3">
    <p-button label="Close" icon="pi pi-times" (onClick)="onCancel()" />
  </div>
</div>
